"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecUtils = void 0;
const decimal_1 = require("./decimal");
class DecUtils {
    static trim(dec) {
        let decStr = typeof dec === "string" ? dec : dec.toString();
        if (decStr.indexOf(".") < 0) {
            return decStr;
        }
        for (let i = decStr.length - 1; i >= 0; i--) {
            if (decStr[i] === "0") {
                decStr = decStr.slice(0, i);
            }
            else {
                break;
            }
        }
        if (decStr.length > 0) {
            if (decStr[decStr.length - 1] === ".") {
                decStr = decStr.slice(0, decStr.length - 1);
            }
        }
        return decStr;
    }
    static getPrecisionDec(precision) {
        if (DecUtils.precisions[precision.toString()]) {
            return DecUtils.precisions[precision.toString()];
        }
        let dec = new decimal_1.Dec(1);
        for (let i = 0; i < precision; i++) {
            dec = dec.mul(new decimal_1.Dec(10));
        }
        DecUtils.precisions[precision.toString()] = dec;
        return dec;
    }
}
exports.DecUtils = DecUtils;
DecUtils.precisions = {};
//# sourceMappingURL=dec-utils.js.map